import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Rotas públicas (indexáveis). Todo o resto é app privado → noindex.
const PUBLIC_PATHS = ['/', '/login', '/cadastro', '/orcamento', '/redefinir-senha'];

export const isPublicPath = (pathname = '') =>
  PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

const garantirMeta = (name) => {
  let meta = document.head.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }

  return meta;
};

/**
 * Ajusta `robots` conforme a rota. Como o app é uma SPA, sem isso o crawler
 * veria a mesma meta em todas as páginas (e poderia indexar telas privadas).
 */
const RouteMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const publica = isPublicPath(pathname);
    garantirMeta('robots').setAttribute('content', publica ? 'index, follow' : 'noindex, nofollow');
    return () => {
      // Não remove a meta: apenas restaura o padrão público ao desmontar.
      garantirMeta('robots').setAttribute('content', 'index, follow');
    };
  }, [pathname]);

  return null;
};

export default RouteMeta;
